import Vue from 'vue'
import App from './App.vue'
import VueMq from 'vue-mq'

Vue.config.productionTip = false
 
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 600,
    md: 1250,
    lg: Infinity,
  },
  defaultBreakpoint: 'sm' // customize this for SSR
})

new Vue({
  render: h => h(App),
}).$mount('#windraftausbau-hessen-map')
